import { render, staticRenderFns } from "./FollowUpEnvelopeModal.vue?vue&type=template&id=0fbc1a3c&lang=pug"
import script from "./FollowUpEnvelopeModal.vue?vue&type=script&lang=js"
export * from "./FollowUpEnvelopeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports